// Modal de Autenticação
import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import LoginForm from './LoginForm';
import RegisterForm from './RegisterForm';
import EmailVerificationForm from './EmailVerificationForm';
import ForgotPasswordModal from './auth/ForgotPasswordModal';

function AuthModal({ isOpen, onClose, onSuccess, initialMode = 'login' }) {
  const [mode, setMode] = useState(initialMode);
  const [verificationData, setVerificationData] = useState(null);
  const [showForgotPassword, setShowForgotPassword] = useState(false);

  // Atualizar o modo quando initialMode mudar
  useEffect(() => {
    setMode(initialMode);
  }, [initialMode]);

  // Função para lidar com erros de email não verificado do login
  const handleEmailNotVerified = (data) => {
    if (process.env.NODE_ENV === 'development') {
      console.log('Email não verificado detectado no login');
    }
    setVerificationData({
      email: data.email,
      fromLogin: true,
      error: data.error
    });
    setMode('verify');
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      {/* Backdrop */}
      <div 
        className="fixed inset-0 bg-black bg-opacity-50 transition-opacity"
        onClick={onClose}
      />
      
      {/* Modal */}
      <div className="flex min-h-full items-center justify-center p-4">
        <div className="relative bg-white rounded-lg shadow-xl max-w-md w-full">
          {/* Botão de fechar */}
          <button
            onClick={onClose}
            className="absolute top-4 right-4 p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-full transition-colors"
            aria-label="Fechar"
          >
            <X className="w-5 h-5" />
          </button>

          {/* Conteúdo */}
          <div className="p-6">
            {mode === 'login' ? (
              <LoginForm 
                onSwitchToRegister={() => setMode('register')}
                onClose={onClose}
                onEmailNotVerified={handleEmailNotVerified}
                onForgotPassword={() => setShowForgotPassword(true)}
                onSuccess={(user) => {
                  onClose();
                  if (onSuccess) onSuccess(user, 'login');
                }}
              />
            ) : mode === 'register' ? (
              <RegisterForm 
                onSwitchToLogin={() => setMode('login')}
                onClose={onClose}
                onRegistrationSuccess={(data) => {
                  if (data.requiresVerification) {
                    setVerificationData({
                      email: data.user.email,
                      user: data.user,
                      fromLogin: false
                    });
                    setMode('verify');
                  } else {
                    onClose();
                    if (onSuccess) onSuccess(data.user, 'register');
                  }
                }}
              />
            ) : mode === 'verify' ? (
              <EmailVerificationForm
                email={verificationData?.email}
                fromLogin={verificationData?.fromLogin}
                onSuccess={(user) => {
                  setMode('login');
                  setVerificationData(null);
                  onClose();
                  if (onSuccess) onSuccess(user, 'verify');
                }}
                onBackToLogin={() => {
                  setMode('login');
                  setVerificationData(null);
                }}
              />
            ) : null}
          </div>
        </div>
      </div>

      {/* Modal de Forgot Password */}
      <ForgotPasswordModal
        isOpen={showForgotPassword}
        onClose={() => setShowForgotPassword(false)}
        onBackToLogin={() => {
          setShowForgotPassword(false);
          setMode('login');
        }}
      />
    </div>
  );
}

export default AuthModal;
